const { cornerLineLength, panLineMargin } = specConfig;
const { trenchWallBuffer } = panManufacturingReq;

class PanBuilderBase {

    constructor( x = 0, y = 0, scale = 8) {

        this.defaults = {
            font: null,
            dashedLine: [20, 3, 5, 3],
        };

        this.state = {
            panX: x,
            panY: y,
            scale,
        };

        const bg = this._createBackground(1000, 1000);
        this.backgroundPattern = drawingContext.createPattern(bg.canvas, 'no-repeat');
    }

    scale(amount) {
        this.state.scale = amount;
    }

    splashWallWidth(amount) {
        this.state.splashWallWidthInches = amount;
    }

    curbType(type) {
        this.state.curbType = type;
    }

    curbWidth(amount) {
        this.state.curbWidthInches = amount;
    }

    curbHeight(amount) {
        this.state.curbHeightInches = amount;
    }

    grateStyle(type) {
        this.state.grateStyle = type;
    }

    dimensions(width, depth) {
        this.state.panWidthInches = +(width);
        this.state.panDepthInches = +(depth);
        this.state.aspectRatio = Math.round(width / depth, 2);
    }

    drainLocation(side, back, position) {
        this.state.drainSideDistanceInches = +(side);
        this.state.drainBackDistanceInches = +(back);
        this.state.drainPosition = position;
    }

    static _formatNumber(n) {
        return (Math.round(n * 100) / 100).toFixed(2);
    }

    static _findClosest(arr, num) {

    }

    _getTrenchSize(width) {
        this.state.trenchGrateWidthInches = trenchGrateWidths.reduce((current, previous) => {
            if (current < width && (width - current) >= trenchWallBuffer) return current;
            return previous;
        });

        return this.state.trenchGrateWidthInches;
    }

    _getTextWidth(text) {
        return Math.ceil(drawingContext.measureText(text).width);
    }

    _createTrenchGrate(size, vars) {
        const { p5, state: {
            drainPosition, scale,
        } } = this;

        const {
            panDepth, curbWidth,
            drainY, splashWallWidth,
            grateDepth,
        } = vars;

        noFill();
        stroke('black');
        strokeWeight(1);

        const grateWidthInches = this._getTrenchSize(size);
        const grateWidth = Math.round(grateWidthInches * scale);

        rect(
            -(grateDepth / 2), -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            grateDepth, grateWidth,
        );

        let trenchX = 40;
        let trenchLineOffset = (grateDepth / 2) + panLineMargin;
        let trenchLineLength = cornerLineLength * 0.55;

        if (drainPosition === 'Right') {
            trenchX = -40;
            trenchLineOffset = -(cornerLineLength * 0.55);
            trenchLineLength = -((grateDepth / 2) + panLineMargin);
        }

        line(
            trenchLineOffset, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            trenchLineLength, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
        );

        line(
            trenchLineOffset, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
            trenchLineLength, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
        );

        this._createMeasureLine(
            trenchX, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth - grateWidth) / 2)),
            trenchX, -(drainY - splashWallWidth - ((panDepth - splashWallWidth - curbWidth + grateWidth) / 2)),
            grateWidthInches,
            25,
        );
    }

    _createBackTrenchGrate(size, vars) {
        const { p5, state: {
            drainPosition, scale, curbType,
        } } = this;

        const {
            panDepth, curbWidth,
            drainY, splashWallWidth,
            grateDepth, panWidth,
            drainX,
        } = vars;

        noFill();
        stroke('black');
        strokeWeight(1);

        const grateWidthInches = this._getTrenchSize(size);
        const grateWidth = Math.round(grateWidthInches * scale);
        let trenchStart = -(drainX - splashWallWidth - ((panWidth - grateWidth - (splashWallWidth * 2)) / 2));
        let trenchEnd = panWidth - drainX - splashWallWidth - ((panWidth - grateWidth - (splashWallWidth * 2)) / 2);

        if (curbType === 'Right Dual Curb') {
            trenchStart -= curbWidth / 2;
            trenchEnd -= curbWidth / 2;
        }

        if (curbType === 'Left Dual Curb') {
            trenchStart += curbWidth / 2;
            trenchEnd += curbWidth / 2;
        }

        rect(
            trenchStart,
            -(grateDepth / 2),
            grateWidth, grateDepth,
        );

        line(
            trenchStart,
            (grateDepth / 2) + panLineMargin,
            trenchStart,
            cornerLineLength * 0.55,
        );

       line(
            trenchEnd,
            (grateDepth / 2) + panLineMargin,
            trenchEnd,
            cornerLineLength * 0.55,
        );

        this._createMeasureLine(
            trenchStart,
            (grateDepth / 2) + panLineMargin + 15,
            trenchEnd,
            (grateDepth / 2) + panLineMargin + 15,
            grateWidthInches,
            25,
        );
    }

    _createMeasureLine(x1, y1, x2, y2, textValue, offset = 0) {
        const { p5, state: { drainPosition } } = this;
        const midpoint = createVector((x1 + x2) / 2, (y1 + y2) / 2);
        const lineHeight = (y1 === y2) ? 5 : 0;
        const textMarginMin = 50;

        strokeWeight(1);
        noFill();
        stroke('black');
        line(x1, y1, x2, y2);
        this._createArrows(x1, y1, x2, y2);

        if (textValue) {
            const textWidth = this._getTextWidth(textValue);
            let y = midpoint.y + lineHeight;
            let x = midpoint.x + lineHeight;

            if (x1 === x2) {
                const textMarginY = (y2 - y1) - textWidth;

                if (textMarginY <= textMarginMin) {
                    y = y2 + textMarginMin;

                    strokeWeight(1);
                    line(x2, y2, x2, y2 + textMarginMin/3);
                }

                push();
                translate(midpoint.x, y);
                rotate(-HALF_PI);

                this._createText(
                    textValue,
                    textMarginMin/4 + offset, 5,
                );

                pop();
            } else if (y1 === y2) {
                const textMarginX = (x2 - x1) - textWidth;

                if (textMarginX <= textMarginMin) {
                    strokeWeight(1);

                    if (drainPosition === 'Left') {
                        x = x1 + textMarginMin + 50;

                        line(x1, y2, x1 + 70, y2);
                    } else {
                        x = -(x1 + textMarginMin);
                        line(x1 - textMarginMin, y2, x1, y2);
                    }
                }

                this._createText(
                    textValue,
                    x,
                    midpoint.y + lineHeight,
                );
            }
        }
    }

    _createArrow(x, y, direction, arrowHeight = 10, arrowWidth = 3, leadLine = true) {
        const { p5 } = this;

        strokeWeight(0);
        fill(0);

        if (direction === 'up') {
            triangle(
                x, y - arrowHeight,
                x + arrowWidth, y,
                x - arrowWidth, y,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x, y + arrowHeight);
            strokeWeight(0);
        }

        if (direction === 'down') {
            triangle(
                x, y + arrowHeight,
                x + arrowWidth, y,
                x - arrowWidth, y,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x, y - arrowHeight);
            strokeWeight(0);
        }

        if (direction === 'left') {
            triangle(
                x - arrowHeight, y,
                x, y + arrowWidth,
                x, y - arrowWidth,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x + arrowHeight, y);
            strokeWeight(0);
        }

        if (direction === 'right') {
            triangle(
                x + arrowHeight, y,
                x, y + arrowWidth,
                x, y - arrowWidth,
            );
            strokeWeight(1);
            if (leadLine) line(x, y, x - arrowHeight, y);
            strokeWeight(0);
        }
    }

    _createArrows(x1, y1, x2, y2) {
        const arrowHeight = 5;

        // Vertical
        if (x1 === x2) {
            if (y1 < y2) {
                this._createArrow(x1, y1 + arrowHeight, 'up', arrowHeight);
                this._createArrow(x2, y2 - arrowHeight, 'down', arrowHeight);
            } else {
                this._createArrow(x1, y1 - arrowHeight, 'down', arrowHeight);
                this._createArrow(x2, y2 + arrowHeight, 'up', arrowHeight);
            }
        }

        // Horizontal
        if (y1 === y2) {
            if (x1 < x2) {
                this._createArrow(x1 + arrowHeight, y1, 'left', arrowHeight);
                this._createArrow(x2 - arrowHeight, y2, 'right', arrowHeight);
            } else {
                this._createArrow(x1 - arrowHeight, y1, 'right', arrowHeight);
                this._createArrow(x2 + arrowHeight, y2, 'left', arrowHeight);
            }
        }
    }

    _createText(textValue, x, y, renderMatte = true) {
        const { p5, constructor: { _formatNumber } } = this;
        const formatedText = _formatNumber(textValue);
        const renderedText = drawingContext.measureText(formatedText);
        const txtWidth = Math.ceil(renderedText.width);
        const textHeight = Math.ceil(renderedText.actualBoundingBoxAscent);
        const padding = 2;

        strokeWeight(0);

        if (renderMatte) {
            fill('white');

            rect(
                x - (txtWidth / 2) - padding, y - textHeight - padding,
                txtWidth + (padding * 2), textHeight + (padding * 2),
            );
        }

        fill(0);
        text(formatedText, x - (renderedText.width / 2), y);
    }

    _createLine(verts, weight = 1, arrows = true, arrowSize = 25) {
        const { orgX, orgY, destX, destY } = verts;

        this.strokeWeight(weight);
        this.line(orgX, orgY, destX, destY);

        if (arrows) {
            this._createArrows(verts);
        }
    }

    _createBackground(width, height, lineSpacing = 3.5) {
        const { p5 } = this;
        const bg = createGraphics(width, height);

        bg.pixelDensity(2);
        bg.strokeWeight(0.5);
        bg.noFill();
        bg.stroke(0);

        let x = 0;
        let y = height;

        while (y >= 0) {
            bg.line(x, y, y, 0);
            y -= lineSpacing;
        }

        x = 0;
        y = height;

        while (x <= width) {
            bg.line(x, width, width, x);
            x += lineSpacing;
        }

        return bg;
    }

    _createDrain(vars) {
        const { p5, state: { scale } } = this;

        const {
            drainWidth, drainHeight, drainInnerDiameter,
            plankFloorThickness, drainExposed, drainPlateWidth,
            vLine,
        } = vars;

        const drainRecess = plankFloorThickness * 0.50;
        const bg = createGraphics(100, 100);

        bg.noStroke();
        bg.fill('black');

        // T Shaped Drain Insert
        bg.translate(10, 10);
        bg.beginShape();
        bg.vertex(0, 0);
        bg.vertex(drainWidth, 0);
        bg.vertex(drainWidth, drainRecess);
        bg.vertex(drainWidth - ((drainWidth - drainInnerDiameter) / 2), drainRecess);
        bg.vertex(drainWidth - ((drainWidth - drainInnerDiameter) / 2), drainHeight + 1);

        bg.vertex((drainWidth - drainInnerDiameter) / 2, drainHeight + 1);
        bg.vertex((drainWidth - drainInnerDiameter) / 2, drainRecess);
        bg.vertex(0, drainRecess);
        bg.vertex(0, 0);
        bg.endShape();

        bg.rect(
            1, drainRecess,
            drainWidth - 2, 5
        );

        // Pan Bottom Shroud
        const dl1 = 5;
        bg.rect(
            (drainWidth / 2) - ((dl1 * scale) / 2),
            plankFloorThickness,
            dl1 * scale,
            1,
        );

        const dl2 = 3.66;

        bg.rect(
            (drainWidth / 2) - ((dl2 * scale) / 2),
            plankFloorThickness + 1,
            dl2 * scale,
            2,
        );

        const dl3 = 3.17;

        bg.rect(
            (drainWidth / 2) - ((dl3 * scale) / 2),
            plankFloorThickness + 3,
            dl3 * scale,
            2,
        );

        bg.fill('white');

        bg.rect(
            ((drainWidth - drainInnerDiameter) / 2) + 2,
            drainHeight - drainExposed + 1,
            drainInnerDiameter - 4,
            drainExposed - 1,
        );

        bg.rect(
            ((drainWidth - drainInnerDiameter) / 2) + 4,
            1,
            drainInnerDiameter - 8,
            drainHeight - drainExposed - 5,
        );

        // bg.beginShape();
        // bg.vertex(((drainWidth - drainPlateWidth) / 2) + 2, 1);
        // bg.vertex((drainWidth - ((drainWidth - drainPlateWidth) / 2)) - 2, 1);
        // bg.vertex((drainWidth - ((drainWidth - drainPlateWidth) / 2)) - 2, 2);
        // bg.vertex(drainWidth / 2, 3);
        // bg.vertex(((drainWidth - drainPlateWidth) / 2) + 2, 2);
        // bg.vertex(((drainWidth - drainPlateWidth) / 2) + 2, 1);
        // bg.endShape();

        bg.rect(
            1,
            drainPlateWidth,
            1,
        );

        bg.stroke('black');
        bg.strokeWeight(1);
        bg.line(drainWidth / 2, -3, drainWidth / 2, drainHeight + 3);

        // Width measure lines
        bg.line(
            drainWidth - drainPlateWidth - 3,
            drainHeight,
            drainWidth - drainPlateWidth - 3,
            drainHeight + vLine,
        );

        bg.line(
            drainWidth - (drainWidth - drainPlateWidth) + 3,
            drainHeight,
            drainWidth - (drainWidth - drainPlateWidth) + 3,
            drainHeight + vLine,
        );

        return bg;
    }

    _createTrenchDrain(vars) {
        const { p5, state: { scale } } = this;

        const {
            drainWidth, drainHeight, drainInnerDiameter,
            plankFloorThickness, drainExposed, drainPlateWidth,
            vLine, panHeight, grateThickness, trenchFloorThickness,
        } = vars;

        const drainRecess = plankFloorThickness * 0.50;
        const bg = createGraphics(100, 100);

        bg.noStroke();
        bg.fill('black');

        // T Shaped Drain Insert
        bg.translate(10, 10);
        bg.beginShape();
        bg.vertex(0, 2);
        bg.vertex(drainWidth, 2);
        bg.vertex(drainWidth, drainRecess);
        bg.vertex(drainWidth - ((drainWidth - drainInnerDiameter) / 2), drainRecess);
        bg.vertex(drainWidth - ((drainWidth - drainInnerDiameter) / 2), drainHeight);

        bg.vertex((drainWidth - drainInnerDiameter) / 2, drainHeight);
        bg.vertex((drainWidth - drainInnerDiameter) / 2, drainRecess);
        bg.vertex(0, drainRecess);
        bg.vertex(0, 0);
        bg.endShape();

        bg.rect(
            1, drainRecess,
            drainWidth - 2, 5,
        );

        // Pan Bottom Shroud
        const dl1 = 5;
        bg.rect(
            (drainWidth / 2) - ((dl1 * scale) / 2),
            plankFloorThickness,
            dl1 * scale,
            1,
        );

        const dl2 = 3.66;

        bg.rect(
            (drainWidth / 2) - ((dl2 * scale) / 2),
            plankFloorThickness + 1,
            dl2 * scale,
            2,
        );

        const dl3 = 3.17;

        bg.rect(
            (drainWidth / 2) - ((dl3 * scale) / 2),
            plankFloorThickness + 3,
            dl3 * scale,
            2,
        );

        bg.fill('white');

        bg.rect(
            ((drainWidth - drainInnerDiameter) / 2) + 2,
            drainHeight - drainExposed,
            drainInnerDiameter - 4,
            drainExposed - 1,
        );

        bg.rect(
            1,
            drainPlateWidth,
            1,
        );

        bg.stroke('black');
        bg.strokeWeight(1);
        bg.line(drainWidth / 2, 0, drainWidth / 2, drainHeight + 3);

        // Width measure lines
        bg.line(
            drainWidth - drainPlateWidth - 3,
            drainHeight,
            drainWidth - drainPlateWidth - 3,
            drainHeight + vLine,
        );

        bg.line(
            drainWidth - (drainWidth - drainPlateWidth) + 3,
            drainHeight,
            drainWidth - (drainWidth - drainPlateWidth) + 3,
            drainHeight + vLine,
        );

        return bg;
    }

}